import { FormEvent, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CATALOG_ARCHIVE_URL, CATALOG_PRICELIST_URL } from '../../../config';
import { CategoriesContext } from '../../../App';
import MenuItem from './menu-item';

function NewIekSidebar() {
    const { categories, isProduct } = useContext(CategoriesContext);
    const [search, setSearch] = useState('');
    const nav = useNavigate();
    const onSearch = (e: FormEvent) => {
        e.preventDefault();
        // @ts-ignore
        const input = (e.target as HTMLFormElement).elements['search'];
        const val = input.value;
        nav('/search/?q=' + val);
    };
    return (
        <div className="catalog__sidebar" onClick={(e) => e.stopPropagation()}>
            <div className="catalog-sidebar catalog-sidebar--desktop">
                {!isProduct && (
                    <>
                        <a href={CATALOG_PRICELIST_URL} className="ui-button ui-button--dark ui-button--file">
                            <i className="far fa-file-pdf" />
                            <span>Скачать прайс-лист</span>
                        </a>
                        <a href={CATALOG_ARCHIVE_URL} className="ui-button ui-button--dark ui-button--file">
                            <i className="far fa-file-pdf" />
                            <span>Скачать полный каталог</span>
                        </a>
                    </>
                )}
                <div className="catalog-sidebar__top">
                    {isProduct && <h5 className="product-catalog__title">Каталог продукции</h5>}
                    <div className="catalog-sidebar__search">
                        <form className="ui-search" onSubmit={onSearch}>
                            <div className="ui-input">
                                <input
                                    name="search"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="ui-input__control"
                                    placeholder="Поиск по каталогу"
                                />
                            </div>
                            <button type="submit" className="ui-search__button">
                                <i className="icon-search" />
                            </button>
                        </form>
                    </div>
                </div>
                <ul className="catalog-menu">
                    {categories.map((item) => (
                        <MenuItem key={item.slug} {...item} />
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default NewIekSidebar;
